import { NavParams, ToastController, AlertController } from 'ionic-angular';
import { Component, OnInit, Input } from '@angular/core';
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';

import { SPHCompany, SPHLoggedInUser, LicenseManagerService, SPHLicense } from '../../shared/shared';

@Component({
    selector: 'lm-company-details',
    templateUrl: 'company-details.component.html'
})

export class CompanyDetailsComponent {
    private formGroup: FormGroup;

    private _user: SPHLoggedInUser;
    @Input() set user(user: SPHLoggedInUser) {
        this._user = user;

        if (user !== undefined) {
            this.reloadCompany();
        }
    }
    get user(): SPHLoggedInUser {
        return this._user;
    }

    private _company: SPHCompany;
    @Input() set company(company: SPHCompany) {
        this._company = company;

        if (company !== undefined) {
            this.formGroup.patchValue({
                email: company.email,
                identnr: company.identnr,
                name: company.name,
                location: company.location,
            });
        }

    }

    get company(): SPHCompany {
        return this._company;
    }

    private smtpCredentials: { host: string, port: number, secure: boolean, user: string, pass: string };

    private licenses: SPHLicense[] = [];

    private password: string = '';
    private passwordRepeated: string = '';

    constructor(private navParams: NavParams, private formBuilder: FormBuilder, private licenseMangerService: LicenseManagerService, private alertController: AlertController, private toastController: ToastController) {

        const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        this.formGroup = this.formBuilder.group({
            identnr: ['', Validators.required],
            name: ['', Validators.required],
            email: ['', [Validators.pattern(EMAIL_REGEXP) , Validators.required]],
            location: [''],
        }, {
                // validator: CompanyDetailsComponent.matchPasswords
            });
        this.company = this.navParams.get('company');
        this.user = this.navParams.get('user');

    }

    public didTapSaveCompany() {
        const company = new SPHCompany();

        company.name = this.formGroup.value['name'];
        company.location = this.formGroup.value['location'];
        company.email = this.formGroup.value['email'];

        company.id = this.company.id;

        this.licenseMangerService.patchCompany(company, this.user.jwt).subscribe((patchedCompany) => {
            const toast = this.toastController.create({ message: 'Firmeninformationen gespeichert', duration: 3000 });
            toast.present();
            this.reloadCompany();
        }, this.licenseMangerService.handleHttpError('Fehler beim Speichern der Firmendaten'));
    }

    public validatePasswordFields(): boolean {
        return this.password !== '' && this.password === this.passwordRepeated;
    }

    public shouldSaveSMTPData(data: { host: string, port: number, secure: boolean, user: string, pass: string }) {
        // save...
    }

    public shouldResetSMTPData(event) {
        // TODO actually reset data
        const smtp = this.smtpCredentials;
        this.smtpCredentials = undefined;
        this.smtpCredentials = smtp;
    }

    public reloadCompany() {
        this.licenseMangerService.getCompany(this.company.id, this.user.jwt).subscribe((company) => {
            this.company = company;
        }, this.licenseMangerService.handleHttpError('Fehler bei Company-Abruf'));

        this.licenseMangerService.getLicenses(this.company.id, this.user.jwt).subscribe((licenses) => {
            this.licenses = licenses;
        }, this.licenseMangerService.handleHttpError('Fehler bei Lizenzen-Abruf'));
    }

    public didTapSavePassword() {
        this.licenseMangerService.setAdminPasswordForCompany(this.company.id, this.password, this.user.jwt).subscribe(() => {
            this.passwordRepeated = '';
            this.password = '';
            const alert = this.alertController.create({
                title: 'Admin-Passwort gesetzt',
                message: 'Der Firmenadmin kann sich nun mit dem Passwort und dem Nutzernamen "' + this.company.identnr + '" anmelden.',
                buttons: [
                    {
                        text: 'OK',
                        role: 'cancel',
                    },
                ]
            });
            alert.present();
        }, this.licenseMangerService.handleHttpError('Fehler Anlegen des Passwort'));
    }
}



// WEBPACK FOOTER //
// ./src/app/features/companyLicenseManagement/companyDetailsComponent/company-details.component.ts